import { combineReducers } from 'redux';
import LoginReducer from './LoginReducer';
import ForgotPasswordReducer from './ForgotPasswordReducer';
import ResetPasswordReducer from './ResetPasswordReducer';
import UpdateUtilisateursReducer from './UpdateUtilisateursReducer';
import UpdateUtilisateurPasswordReducer from './UpdateUtilisateurPasswordReducer';
import FormBuilderReducer from './FormBuilderReducer';
import ListeFormsReducer from './ListeFormsReducer';
import UpdateFormReducer from './UpdateFormReducer';
import PublishFormReducer from './PublishFormReducer';
import ListUtilisateursReducer from './ListUtilisateursReducer';
import CreateUtilisateursReducer from './CreateUtilisateurReducer';
import ActivDesactivUtilisateursReducer from './ActivDesactivUtilisateursReducer';
import statisticGeneralReducer from './StatisticGeneralReducer';
import JournalAuditReducer from './JournalAuditReducer';
import LimitReponseReducer from './LimitReponseReducer';
import GetFormFromIdReducer from './GetFormFromIdReducer';
import CreateResponseReducer from './CreateResponseReducer';
import ListReponsesReducer from './ListReponsesReducer';
import ResponsesGroupedByQuestionReducer from './ResponsesGroupedByQuestionReducer';
import PartageFormReducer from './PartageFormReducer';
import ListParametrageFormReducer from './ListParametrageFormReducer';
import ConfigurLimitReponseReducer from './ConfigurLimitReponseReducer';
import ConfigurExpirationReponseReducer from './ConfigurExpirationReponseReducer';
import DeletResponseFormReducer from './DeletResponseFormReducer';


const rootReducer = combineReducers({
    auth: LoginReducer,
    forgotPassword: ForgotPasswordReducer,
    resetPassword: ResetPasswordReducer,
    updateUtilisateur: UpdateUtilisateursReducer,
    updateUtilisateurPassword: UpdateUtilisateurPasswordReducer,
    creatFormulaireBuilder: FormBuilderReducer,
    listeDesFormulaires : ListeFormsReducer,
    updateFormulaire : UpdateFormReducer,
    publishForm: PublishFormReducer,
    utilisateurs: ListUtilisateursReducer,
    createUtilisateur: CreateUtilisateursReducer, 
    activDesactivUtilisateur: ActivDesactivUtilisateursReducer,
    statisticsGeneral: statisticGeneralReducer,
    auditLogs: JournalAuditReducer,
    fermerReponses: LimitReponseReducer,
    partageForm: PartageFormReducer,
    getFormById: GetFormFromIdReducer,
     createResponse: CreateResponseReducer,
     listReponses: ListReponsesReducer,
     responsesGroupedByQuestion: ResponsesGroupedByQuestionReducer,
     listDesParametresForm: ListParametrageFormReducer,
     creatLimitReponse: ConfigurLimitReponseReducer,
     createExpiration: ConfigurExpirationReponseReducer,
     deleteResponseForm: DeletResponseFormReducer,
    
});

export default rootReducer;
